import React, { useEffect } from 'react'
import { Line } from 'react-chartjs-2'
import '../../App.scss'
import './FinalStage.scss'
import { connect } from 'react-redux'
import { getDailyValuesChartRequest } from '../../redux/trainer/trainer.actions'

const DailyValues = ({ getDailyValuesChartRequest, responseGetDailyValuesChart }) => {

    const idGame = localStorage.getItem("game_id")
    useEffect(() => {
        getDailyValuesChartRequest(idGame)
    }, [idGame])

    var finalData = []
    if (responseGetDailyValuesChart && responseGetDailyValuesChart.datasets.length > 0)
        responseGetDailyValuesChart.datasets.map(d => {
            finalData.push(
                {
                    label: d.data.name,
                    fill: false,
                    backgroundColor: d.data.color,
                    borderColor: d.data.color,
                    borderWidth: 2,
                    data: d.data.points,
                    hidden: (!d.data.visible),
                    lineTension: 0,
                }
            )
            return finalData
        })

    var state
    if (responseGetDailyValuesChart)
        state = {
            labels: responseGetDailyValuesChart.labels,
            datasets: finalData
        }

    const options = {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                fontSize: 11,
                boxWidth: 20,
                boxHeight: 2
            }
        },
        elements: {
            point: {
                radius: 0
            }
        },
        scales: {
            yAxes: [{
                ticks: {
                    fontSize: 11
                }
            }],
            xAxes: [{
                ticks: {
                    callback: function (tick, index, ticks) {
                        if (tick % 10 === 0)
                            return tick.toLocaleString();

                        return null;
                    },
                    fontSize: 11,
                }
            }]
        }
    }

    return (
        <div className="general_container final_stage">
            <h4 className="subtitle-stage">Daily Values</h4>
            <Line
                data={state}
                options={options}
            />
        </div>
    )
}

const mapStateToProps = state => ({
    responseGetDailyValuesChart: state.trainer.responseGetDailyValuesChart
})

const mapDispatchToProps = dispatch => ({
    getDailyValuesChartRequest: payload => dispatch(getDailyValuesChartRequest(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(DailyValues)